export class UserSettingChangedEvent {

}